import type { TableQueryParams } from "@/v2-backoffice-client/components/table"

// Server-side filters for the sessions list. The list is paged, so filtering
// happens server-side (manualFiltering) to span the whole table rather than
// just the loaded pages.
export type SessionFilters = {
  search?: string
  status?: string
}

// Maps the table's emitted filters onto the server input: Search is the virtual
// column the global search box emits (Table searchColumn) -> name/email match;
// Status is the live/revoked select.
export function deriveSessionFilters(params: TableQueryParams): SessionFilters {
  const next: SessionFilters = {}
  for (const f of params.filters ?? []) {
    if (f.column === "Search" && f.contains) next.search = f.contains
    else if (f.column === "Status" && f.eq != null) next.status = f.eq
  }
  return next
}
